import React, { Component } from "react";
import "./SignIn.css";
import { IoIosEye, IoIosEyeOff, IoIosMail } from "react-icons/io";
import { ReactComponent as EmailSvg } from "../../assets/images/email.svg";
import { ReactComponent as KeySvg } from "../../assets/images/key.svg";
import logo from "../../assets/images/logo.png";
import qs from "qs";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import left_arrow from "../../assets/images/left-arrow.svg";
import { BsArrowLeft } from "react-icons/bs";
import Header from '../dashborad/Header';
import {Helmet} from "react-helmet";
import AppService from "../../commons/AppService";

toast.configure();
export default class SignIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validEmail: false,
      validPassword: false,
      emailErrorMsg: "",
      passwordErrorMsg: "",
      email: "",
      password: "",
      emailError: false,
      passwordError: false,
      errors: {},
      errorMsgText: "",
      errorMsg: false,
      isLoading: false,
      isPasswordShow: false,
      focus: false,
      passwordFocus: false,
    };
    this._onFocus = this._onFocus.bind(this);
    this._onFocus2 = this._onFocus2.bind(this);
  }

  _onFocus() {
    if (!this.state.focus) {
      this.setState({
        focus: true,
        passwordFocus: false,
      });
    }
  }
  _onFocus2() {
    if (!this.state.passwordFocus) {
      this.setState({
        focus: false,
        passwordFocus: true,
      });
    }
  }
  togglePasswordVisiblity = () => {
    const { isPasswordShow } = this.state;
    this.setState({
      isPasswordShow: !isPasswordShow,
    });
  };
  validateEmail = (e) => {
    let emailRegExp = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/;
    const email = e.target.value;

    if (email == "") {
      this.setState({
        validEmail: true,
        emailErrorMsg: "Email is required",
      });
    } else if (!email.match(emailRegExp)) {
      this.setState({
        validEmail: true,
        emailErrorMsg: "Please enter the valid email",
      });
    } else {
      this.setState({
        validEmail: false,
        emailErrorMsg: "",
        focus: false,
      });
    }
  };
  validatePassword = (e) => {
    const password = e.target.value;

    if (password == "") {
      this.setState({
        validPassword: true,
        passwordErrorMsg: "Password is required",
      });
    } else {
      this.setState({
        validPassword: false,
        passwordErrorMsg: "",
        passwordFocus: false,
      });
    }
  };
  componentDidMount() {
    // this.refs.email.focus();
  }

  handleKeyPress(value, event) {
    if (event.key === "Enter") {
      this.refs[value].focus();
    }
  }

  handleValidation() {
    const { email, password } = this.state;
    let errors = {};
    let formIsValid = true;
    let emailRegExp = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/;
    const x = "^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$";

    //email
    if (this.state.email == "") {
      formIsValid = false;
      errors["email"] = "Email is required";
      this.setState({
        emailError: true,
      });
    } else if (typeof email !== "undefined") {
      if (!email.match(emailRegExp)) {
        formIsValid = false;
        errors["email"] = "Invalid email address";
        this.setState({
          emailError: true,
        });
      }
    }

    //password
    if (!password) {
      formIsValid = false;
      errors["password"] = "Password is required";
      this.setState({
        passwordError: true,
      });
    }

    this.setState({ errors: errors });
    return formIsValid;
  }
  onSubmit(e) {
    e.preventDefault();

    if (this.handleValidation()) {
      this.setState({
        isLoading: true,
      });

      var service = AppService.getInstance()

      service.loginUser(this.state.email,this.state.password)
        .then((result) => {
          //console.log("ENTER loginUser then",result);
          /*
          localStorage.setItem("token", result.data.token);
          localStorage.setItem("name", result.data.result.Data.Name);
          localStorage.setItem("email", result.data.result.Data.Email);
          */
          this.setState({
            isLoading: false,
          });
          toast.success("Login Successful", {
            autoClose: 2000,
          });
          setTimeout(() => {
            this.props.history.push("/");
          }, 400);

          // Do somthing
        })
        .catch((error) => {
          if (error.response) {
            // Request made and server responded
            console.log(error.response.data);
            toast.error(`${error.response.data.data}`);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
            toast.error("Oops Something Went Wrong");
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
            toast.error("Oops Something Went Wrong");
          }

          this.setState({
            isLoading: false,
          });
        });
    }
  }

  render() {
    const { errors, validEmail } = this.state;
    const { isPasswordShow } = this.state;
    return (
      <>
       <Helmet>
          <title>Login | Surfable Maps</title>
          <meta name="description" content=" Login to your Surfable Account"></meta>
        
        </Helmet>
        <Header />
        <div className="imageBackground">
          {/* <div className="overlay"></div> */}
          <div className="container">
            <div className="main">
              <div className="left-side">
                <img
                  src={logo}
                  className={"logoImg"}
                  style={{ marginBottom: "4px" }}
                />

                <p className="left-side-text">
                  <b className="lgntxt">10 day surf wave height & period maps for Southern California, Northern California and Hawaii</b>
                </p>
                {/* <p className="left-side-text">
              Create an account to access the SURFER Swellmaps
              </p> */}
                <div
                  className="left-arrow-back-to-home"
                  onClick={() => this.props.history.push("/")}
                >
                  <BsArrowLeft
                    // size="30px"
                    style={{
                      position: "relative",
                      fontSize: "30px",
                      top: "-6px",
                    }}
                  />
                  <span style={{ marginLeft: "5px", color: " #1976D2" }}>
                    Back To Home
                </span>
                </div>
              </div>

              <div className="right-side">
                <p className="login-text"> Login </p>
                <p className="sub-text">
                  Login so you can manage your Premium Subscription
              </p>
                {/* <div style={{ maxWidth: "600px" }}> */}

                <div
                  className="input-container"
                  style={{
                    marginBottom:
                      this.state.validEmail || this.state.emailError ? 0 : "5%",
                    border:
                      this.state.validEmail || this.state.emailError
                        ? "1px solid red"
                        : this.state.focus
                          ? "3px solid #2680EB0F"
                          : "1px solid #CDDEF3",
                  }}
                >
                  <EmailSvg className="icons" />
                  <input
                    type="email"
                    placeholder="Email Address"
                    ref="email"
                    onBlur={this.validateEmail}
                    onFocus={this._onFocus}
                    onChange={(e) =>
                      this.setState({
                        email: e.target.value,
                        emailError: false,
                        errorMsg: false,
                        validEmail: false,
                        emailErrorMsg: "",
                      })
                    }
                    value={this.state.email}
                    onKeyPress={(event) => this.handleKeyPress("password", event)}
                  />
                </div>
                {validEmail || this.state.emailError ? (
                  <p style={{ marginBottom: "5%" }} className="error-Text">
                    {this.state.emailErrorMsg || errors["email"]}
                  </p>
                ) : (
                    ""
                  )}
                <div
                  className="input-container"
                  style={{
                    border:
                      this.state.validPassword || this.state.passwordError
                        ? "1px solid red"
                        : this.state.passwordFocus
                          ? "3px solid #2680EB0F"
                          : "1px solid #CDDEF3",
                  }}
                >
                  <KeySvg className="icons" />
                  <input
                    placeholder="Password"
                    type={isPasswordShow ? "text" : "password"}
                    ref="password"
                    onChange={(e) =>
                      this.setState({
                        password: e.target.value,
                        passwordError: false,
                        validPassword: false,
                        passwordErrorMsg: "",
                      })
                    }
                    onFocus={this._onFocus2}
                    onBlur={this.validatePassword}
                    value={this.state.password}
                  />
                  {!isPasswordShow ? (
                    <IoIosEye
                      className="eye-icon"
                      size="25px"
                      color="#aaa"
                      onClick={this.togglePasswordVisiblity}
                    />
                  ) : (
                      <IoIosEyeOff
                        className="eye-icon"
                        size="25px"
                        color="#aaa"
                        onClick={this.togglePasswordVisiblity}
                      />
                    )}
                </div>
                {this.state.validPassword || this.state.passwordError ? (
                  <p className="error-Text">
                    {errors["password"] || this.state.passwordErrorMsg}
                  </p>
                ) : null}
                <p
                  onClick={() => {
                    this.props.history.push("/forgot_password");
                  }}
                  className="forgot"
                >
                  Forgot Password?
              </p>
                <button
                  type="submit"
                  className="btn"
                  onClick={this.onSubmit.bind(this)}
                >
                  Login
              </button>

                <p className="footerText">
                  Doesn't have an account?{" "}
                  <span
                    onClick={() => {
                      this.props.history.push("/register");
                    }}
                    style={{
                      color: "#37478594",
                      cursor: "pointer",
                      fontSize: "1em",
                      fontFamily: "Source-SemiBold",
                    }}
                  >
                    Register Here!
                </span>
                </p>
                <div
                  className="footer-left-arrow"
                  onClick={() => this.props.history.push("/")}
                >
                  <BsArrowLeft className="login-left-arrow-icon" />
                  <span style={{ marginLeft: "5px", color: " #1976D2" }}>
                    Back To Home
                </span>
                </div>
              </div>
            </div>
          </div>
          {this.state.isLoading ? (
            <div className="sweet-loading">
              <ClipLoader size={50} color={"#ffffff"} loading={true} />
            </div>
          ) : null}
        </div>
      </>
    );
  }
}
